import React from 'react';
import { withRouter } from 'react-router';
import { isEmpty } from 'lodash';
import { Container } from 'shared-components/grid';
import styles from './styles';

@withRouter
export default class OverviewContanier extends React.Component {
  state = {
    overviewWidgetId: '',
  };

  componentDidMount() {
    if (!isEmpty(this.state.overviewWidgetId)) return;
    const widgetId = window.aiware.mountWidget({
      name: 'DEVELOPER_OVERVIEW',
      elementId: 'developer-overview-root',
    });
    this.setWidgetId(widgetId);
  }

  componentWillUnmount() {
    window.aiware.unmountWidget(this.state.overviewWidgetId);
  }

  setWidgetId = (id) => {
    this.setState({ overviewWidgetId: id });
  };

  render() {
    return (
      <Container sideBarOffset className={styles.overviewContainer}>
        <div id="developer-overview-root" />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/overview/components/OverviewContainer.js